/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const accountRouter = {
  path: '/account',
  component: Layout,
  name: 'menu.name.account.management',
  meta: { title: 'menu.name.account.management', icon: 'user' },
  children: [
    {
      path: 'user',
      component: () => import('@/views/account/user/index'),
      name: 'User',
      meta: { title: 'User', noCache: true }
    },
    {
      path: 'role',
      component: () => import('@/views/account/role/index'),
      name: 'Role',
      meta: { title: 'Role', noCache: true }
    },
    {
      path: 'role-add',
      component: () => import('@/views/account/role/add'),
      name: 'AddRole',
      hidden: true,
      meta: { title: 'AddRole', noCache: true, activeMenu: '/account/role' }
    }
  ]
}
export default accountRouter
